// extracted by mini-css-extract-plugin
export var menu = "main-menu-module--menu--1Ktjp";